// extracted by mini-css-extract-plugin
export var actions = "_7j-8";
export var arrow = "_7j-5";
export var card = "_7j-0";
export var cardWrapper = "_7j-9";
export var fieldName = "_7j-3";
export var newValue = "_7j-6";
export var oldValue = "_7j-4";
export var orangeGlowFade = "_7j-c";
export var productSection = "_7j-1";
export var scrollToBottom = "_7j-b";
export var scrollToBottomAnchor = "_7j-a";
export var scrollToBottomIcon = "_7j-d";
export var showAllButton = "_7j-7";
export var table = "_7j-2";